import React, { createContext, useContext, useState, useCallback } from 'react';
import {
  type VisionType,
  type ColourPalette,
  getColourPalette,
  getSavedVisionType,
  saveVisionType,
} from '../utils/colourPalettes';

interface ColourPaletteContextValue {
  visionType: VisionType;
  palette: ColourPalette;
  setVisionType: (type: VisionType) => void;
}

const ColourPaletteContext = createContext<ColourPaletteContextValue>({
  visionType: 'normal',
  palette: getColourPalette('normal'),
  setVisionType: () => {},
});

export const ColourPaletteProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [visionType, setVisionTypeState] = useState<VisionType>(getSavedVisionType);

  const setVisionType = useCallback((type: VisionType) => {
    setVisionTypeState(type);
    saveVisionType(type);
  }, []);

  const palette = getColourPalette(visionType);

  return (
    <ColourPaletteContext.Provider value={{ visionType, palette, setVisionType }}>
      {children}
    </ColourPaletteContext.Provider>
  );
};

export const useColourPalette = () => useContext(ColourPaletteContext);
